import run from '../../utilities/run';
import $ from 'jquery';
const _ = require("underscore");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run(".retailers_partner-ebay-details-page", ()=>{
	const el = $(".retailers_partner-ebay-details-page");

	const editPartnerUrl = el.data("edit-channel-connection-url");
	const inactivateRetPartnerUrl = el.data("inactivate-channel-url");
	const activateChannelUrl = el.data("activate-channel-url");
	const viewConnectionDetailUrl = el.data("view-channel-connection-detail-url");
	const retpartnerJson = el.data("retailer-partners-detail-info");
	const viewChannelDetailUrl = el.data("view-channel-detail-url");
	const modalInactivateChannel = $("#modalInactivateChannel");
	const modalActivateChannel = $("#modalActivateChannel");
	const ebayConnStatusVal = $("#ebay-conn-status-val");
	const ebayConnAuthMsg = $(".ebay-conn-auth");
	const ebayConnNotAuthMsg = $(".ebay-conn-not-auth");
	const ebayOrderProcessStatusVal = $("#ebay-order-process-status-val");
	const ebayOrdProcessYes= $(".ord-process-yes");
	const ebayOrdProcessNo = $(".ord-process-no");
	const ebayOrdprocessToggleMsg = $(".order-process-yes-no-toggle");
	const ebayOrdProcessStartDateTime = $(".order-process-start-date-time");
	const ebayConnAuthStatusVal = $("#ebay-conn-auth-status-val");
	const ebayActiveInactiveBtn = $("#active-inactive-button");
	const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();


	onLoad();

	function onLoad(){
		checkEbayConnStatus();
		checkOrderProcessStatus();
	}

	function checkEbayConnStatus(){
		if(ebayConnStatusVal.val() == 'true' && ebayConnAuthStatusVal.val() == '1'){
			ebayConnAuthMsg.show();
			ebayConnNotAuthMsg.hide();
		}else if(ebayConnStatusVal.val() == 'false' && ebayConnAuthStatusVal.val() == '1'){
			ebayConnAuthMsg.show();
			ebayConnNotAuthMsg.hide();
		}else{
			ebayConnAuthMsg.hide();
			ebayConnNotAuthMsg.show();
			ebayActiveInactiveBtn.hide();
		}
	}

	function checkOrderProcessStatus(){
		if(ebayOrderProcessStatusVal.val() == 'true'){
			ebayOrdProcessYes.show();
			ebayOrdprocessToggleMsg.show();
			ebayOrdProcessStartDateTime.show();
			ebayOrdProcessNo.hide();
		}else{
			ebayOrdProcessYes.hide();
			ebayOrdprocessToggleMsg.hide();
			ebayOrdProcessStartDateTime.hide();
			ebayOrdProcessNo.show();
		}
	}

	$(".inactivate").on( "click", function() {
		$("#deleteModal").appendTo("body").modal("show");
	});

	$(".activate").on( "click", function() {
		$("#activateModal").appendTo("body").modal("show");
	});

	modalInactivateChannel.on( "click", function() {
		inactivateRetPartner();
	});

	modalActivateChannel.on( "click", function() {
		activateRetailerPartner();
	});

	function inactivateRetPartner() {
		submitModalFlow.showLoadingModal();
		$.ajax({
			url: inactivateRetPartnerUrl,
			success: function(data){
				if(data.match("success")){
				  submitModalFlow.showSuccessModal();
				  setTimeout(function() {
					location.href=viewChannelDetailUrl;
				  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
				}else{
					submitModalFlow.showFailureModal();
				}
			},
			error: function(data) {
				submitModalFlow.showFailureModal();
			}
		});
 	}

 	function activateRetailerPartner() {
		submitModalFlow.showLoadingModal();
		$.ajax({
			url: activateChannelUrl,
			success: function(data){
				if(data.match("success")){
				  submitModalFlow.showSuccessModal();
				  setTimeout(function() {
					location.href=viewChannelDetailUrl;
				  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
				}else{
					submitModalFlow.showFailureModal();
				}
			},
			error: function(data) {
				submitModalFlow.showFailureModal();
			}
		});
	}

});



// WEBPACK FOOTER //
// ./src/pages/createChannel/ebayDetails.js